import { CACHE_MANAGER, Cache } from '@nestjs/cache-manager'
import { Inject, Injectable } from '@nestjs/common'
import { HealthIndicatorResult, HealthIndicatorService } from '@nestjs/terminus'

@Injectable()
export class RedisHealthIndicator {
	constructor(
		@Inject(CACHE_MANAGER) private readonly _cacheManager: Cache,
		private readonly healthIndicatorService: HealthIndicatorService,
	) {}

	async pingCheck(key: string): Promise<HealthIndicatorResult> {
		const indicator = this.healthIndicatorService.check(key)

		const client = (this._cacheManager as any).stores[0].store.redis

		try {
			const response = await client.ping()

			return response === 'PONG' ? indicator.up() : indicator.down()
		} catch (error) {
			return indicator.down(error)
		}
	}
}
